export default "__VITE_ASSET__6GMBOaOO__"